import { useEffect, useState } from "react";

import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import {
  NodeTextField,
  type Props as NodeTextFieldProps,
} from "@/components/doc/right-sidebar/active-node-style/fields/NodeTextField";
import { twMerge } from "@/utils/twMerge";

export type Props = NodeTextFieldProps & {
  onValueChange?: (value: string) => void;
  action?: React.ReactNode;
  validate?: (value: string) => boolean;
};

export const NodeValueField = observer(function NodeValueField({
  value,
  className,
  action,
  labelProps,
  onValueChange = () => {},
  validate = () => true,
  ...props
}: Props) {
  const t = useTranslations("sidebar.activeNode");
  const [inputValue, setInputValue] = useState(value ?? "");

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace(/\s/g, "");

    setInputValue(newValue);

    if (newValue.length > 0 && validate(newValue)) {
      onValueChange(newValue);
    }
  };

  const handleOnBlur = () => {
    setInputValue(value ?? "");
  };

  return (
    <NodeTextField
      value={inputValue}
      name={props.name ?? t("fields.symbol")}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      {...props}
      labelProps={{
        label: t("fields.symbol"),
        className: twMerge("shadow-block dark:shadow-block-inverted", className),
        ...labelProps,
      }}
    >
      {action}
    </NodeTextField>
  );
});
